import { render, staticRenderFns } from "./ReturnList.vue?vue&type=template&id=54c1727c&scoped=true&"
import script from "./ReturnList.vue?vue&type=script&lang=js&"
export * from "./ReturnList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnList.vue?vue&type=style&index=0&id=54c1727c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1727c",
  null
  
)

export default component.exports